<template>
  <div class="modal-content-ticket">
    <div class="modal-header">
      <h2>Novi tiket</h2>
    </div>

    <form class="form--mod" action="post">
      <div id="title-area">
        <label class="col-form-label col-form-label-lg">Naslov</label>
        <input
          v-model="ticket.title"
          class="form-control form-control-lg"
          placeholder="Unesite naslov"
          @focus="errorOccurred = false"
        />
      </div>
      <div id="first-section">
        <div id="description-area">
          <label class="col-form-label col-form-label-lg">Opis</label>
          <textarea
            v-model="ticket.description"
            class="form-control"
            rows="5"
            id="comment"
            placeholder="Unesite opis"
            @focus="errorOccurred = false"
            ref="descriptionArea"
          ></textarea>
        </div>
        <div id="upload-area">
          <upload-button
            @files-selected="getFiles"
            ref="uploadBtn"
          ></upload-button>
          <div
            id="uploaded-files"
            :class="{ 'pointer-cursor': files.length == 0 }"
            @click="addFile"
            @dragover.prevent
            @dragleave.prevent
            @drop="onDrop"
          >
            <div class="upload-wrapper" v-if="files.length == 0">
              <svg
                class="upload-icon pointer-cursor"
                xmlns="http://www.w3.org/2000/svg"
                width="40"
                height="33"
                viewBox="0 0 50 43"
              >
                <path
                  d="M48.4 26.5c-.9 0-1.7.7-1.7 1.7v11.6h-43.3v-11.6c0-.9-.7-1.7-1.7-1.7s-1.7.7-1.7 1.7v13.2c0 .9.7 1.7 1.7 1.7h46.7c.9 0 1.7-.7 1.7-1.7v-13.2c0-1-.7-1.7-1.7-1.7zm-24.5 6.1c.3.3.8.5 1.2.5.4 0 .9-.2 1.2-.5l10-11.6c.7-.7.7-1.7 0-2.4s-1.7-.7-2.4 0l-7.1 8.3v-25.3c0-.9-.7-1.7-1.7-1.7s-1.7.7-1.7 1.7v25.3l-7.1-8.3c-.7-.7-1.7-.7-2.4 0s-.7 1.7 0 2.4l10 11.6z"
                />
              </svg>
              <label class="upload-text pointer-cursor"
                >Izaberite datoteku</label
              >
            </div>
            <!-- <div id="empty-files" v-if="files.length == 0">
            <p>Trenutno nemate dodatih datoteka</p>
            </div>-->
            <div class="file" v-for="(file, index) of files" :key="index">
              <p>{{ file.name }}</p>
              <i
                class="fas fa-times del--mod"
                @click="removeUploadedFile(index)"
              ></i>
            </div>
            <div
              class="upload-more-wrapper pointer-cursor"
              @click="addMoreFiles"
              v-if="files.length > 0"
            >
              <svg
                class="upload-more-icon"
                xmlns="http://www.w3.org/2000/svg"
                width="20"
                height="20"
                viewBox="0 0 50 43"
              >
                <path
                  d="M48.4 26.5c-.9 0-1.7.7-1.7 1.7v11.6h-43.3v-11.6c0-.9-.7-1.7-1.7-1.7s-1.7.7-1.7 1.7v13.2c0 .9.7 1.7 1.7 1.7h46.7c.9 0 1.7-.7 1.7-1.7v-13.2c0-1-.7-1.7-1.7-1.7zm-24.5 6.1c.3.3.8.5 1.2.5.4 0 .9-.2 1.2-.5l10-11.6c.7-.7.7-1.7 0-2.4s-1.7-.7-2.4 0l-7.1 8.3v-25.3c0-.9-.7-1.7-1.7-1.7s-1.7.7-1.7 1.7v25.3l-7.1-8.3c-.7-.7-1.7-.7-2.4 0s-.7 1.7 0 2.4l10 11.6z"
                />
              </svg>
              <span class="upload-more-text">Dodaj datoteku</span>
            </div>
          </div>
        </div>
      </div>
      <label class="col-form-label col-form-label-lg"
        >Izaberite datum nastanka tiketa</label
      >
      <datetime
        @focus="errorOccurred = false"
        v-model="dateCreated"
        type="datetime"
        input-class="form-control form-control-lg"
        placeholder="Izaberite datum nastanka tiketa"
        hidden-name="webstorm"
        value-zone="UTC+1"
        format="dd.MM.yyyy. HH:mm"
        :phrases="{
          ok: 'U redu',
          cancel: 'Otkaži'
        }"
        :max-datetime="maxDate"
      ></datetime>
      <div id="title-area">
        <label class="col-form-label col-form-label-lg">
          Infrastruktura
        </label>
        <model-select
          ref="municipality"
          :options="infrastructures"
          v-model="selectedInfrastructure"
          placeholder="
            Izaberite infrastrukturu"
          class="muni-dropdown add-member-dropdown"
          @input="onInfraChange"
        ></model-select>
        <label class="col-form-label col-form-label-lg">
          Serviser
        </label>
        <model-select
          ref="municipality"
          :options="contractors"
          v-model="selectedContractor"
          placeholder="
            Izaberite servisera"
          class="muni-dropdown add-member-dropdown"
          @input="onContractorChange"
        ></model-select>
        <p v-if="recomendedContractors.length != 0">
          <span v-if="recomendedContractors.length > 1">Predloženi </span>
          <span v-else>Predložen </span>
          <span v-if="recomendedContractors.length > 1">serviseri: </span>
          <span v-else>serviser: </span>
          <span
            v-for="(contractor, index) in recomendedContractors"
            :key="index"
          >
            <span
              class="recomended-contractor"
              @click="selectRecomendedContractor(contractor)"
              >{{ contractor.text }}</span
            >
          </span>
        </p>
        <label class="col-form-label col-form-label-lg">
          Kontakt osoba
        </label>
        <model-select
          ref="municipality"
          :options="contractorContacts"
          v-model="selectedContact"
          placeholder="
            Izaberite kontakt osobu"
          class="muni-dropdown add-member-dropdown"
          @input="onContractorContactChange"
        ></model-select>
      </div>
      <div id="title-area" class="contractor-email-wrapper privacy-wrapper">
        <label class="col-form-label col-form-label-lg"
          >Označi tiket kao privatni
          <div class="custom-tooltip">
            <i class="fas fa-info-circle"></i>
            <span class="tooltiptext"
              >Privatan tiket predstavlja Vašu privatnu belešku i ne mogu ga
              videti ostali članovi zajednice</span
            >
          </div>
        </label>

        <checkbox
          class="ticket-cb"
          :checked="privateTicket"
          @change="tooglePrivacy()"
        ></checkbox>
      </div>
      <div id="title-area" class="contractor-email-wrapper">
        <label class="col-form-label col-form-label-lg"
          >Prosledi tiket serviseru
          <div class="custom-tooltip">
            <i class="fas fa-info-circle"></i>
            <span class="tooltiptext"
              >Tiket će biti poslat serviseru na email</span
            >
          </div>
        </label>
        <checkbox
          class="ticket-cb"
          :checked="sendToContractor"
          :disabled="!selectedContractor"
          @change="sendToContractor = !sendToContractor"
        ></checkbox>
      </div>
      <div id="title-area" class="contractor-email" v-if="sendToContractor">
        <label class="col-form-label col-form-label-lg"
          >Email adresa servisera</label
        >
        <input
          v-model="contractorEmail"
          type="email"
          class="form-control form-control-lg"
          placeholder="Unesite email serviser"
          @focus="errorOccurred = false"
        />
      </div>
    </form>

    <hr />
    <div class="footer">
      <div class="error">
        <transition enter-active-class="animated shake">
          <p class="err-msg" v-if="errorOccurred">{{ errorMessage }}</p>
        </transition>
      </div>

      <div class="buttons" style="text-align:center">
        <button
          type="submit"
          class="btn btn-danger btn--mod"
          @click="closeModal"
        >
          Otkaži
        </button>
        <button
          type="submit"
          class="btn btn-primary btn--mod"
          @click="submitMedia"
          :disabled="loading"
        >
          <span v-if="!loading">Pošalji</span>
          <spinner line-fg-color="#00796b" v-if="loading" />
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import { mapMutations, mapActions, mapState } from 'vuex';
import uploadButton from '@/components/modal/modal-content/ModalContentPollUploadButton.vue';
import axios from '@/axios/axios';
import { ModelSelect } from 'vue-search-select';
import checkbox from '@/components/common/Checkbox';
import { utilService } from '@/util/UtilService.js';
import { Datetime } from 'vue-datetime';
import { DateTime } from 'luxon';

export default {
  components: {
    ModelSelect,
    uploadButton,
    checkbox,
    Datetime
  },
  computed: {
    ...mapState(['loading'])
  },
  data() {
    return {
      files: [],
      ticket: {
        title: '',
        description: '',
        privacy: '0',
        member_id: this.$store.getters.getActiveCommunity.member_id,
        media_ids: []
      },
      removingFile: false,
      errorOccurred: false,
      errorMessage: '',
      contractors: [],
      selectedContractor: null,
      contractorContacts: [],
      selectedContact: null,
      infrastructures: [],
      selectedInfrastructure: null,
      recomendedContractors: [],
      privateTicket: false,
      sendToContractor: false,
      contractorEmail: '',
      contractorContactsAllData: [],
      dateCreated: new Date().toISOString(),
      maxDate: new Date().toISOString()
    };
  },
  async created() {
    const contractorsResult = await this.getAllContractors(false);
    this.contractors = contractorsResult.map(cat => {
      cat.value = cat;
      cat.text = cat.name;
      return {
        value: cat,
        text: cat.name
      };
    });
    const response = await axios.get(
      `/community/${
        this.$store.getters.getActiveCommunity.id
      }/infrastructures-with-contractors`
    );
    this.infrastructures = response.data.data.map(infra => {
      infra.value = infra;
      infra.text = infra.name;
      return {
        value: infra,
        text: infra.name
      };
    });
  },
  methods: {
    ...mapMutations(['loadingStarted', 'loadingFinished']),
    ...mapActions('table', ['getTicketsByCommunity', 'getAllContractors']),
    ...mapMutations('modal', ['closeModal']),
    ...mapActions('modal', ['showSuccessModal', 'showFailModal']),
    tooglePrivacy() {
      this.privateTicket = !this.privateTicket;
      if (this.privateTicket) {
        this.ticket.privacy = '1';
      } else {
        this.ticket.privacy = '0';
      }
    },
    onContractorContactChange(data) {
      if (data) {
        const contractor = this.contractorContactsAllData.find(
          c => c.id == data
        );
        if (contractor && contractor.email) {
          this.contractorEmail = contractor.email;
        }
      } else {
        this.contractorEmail = '';
      }
    },
    async onContractorChange() {
      try {
        if (
          this.selectedContractor &&
          (this.selectedContractor.id || this.selectedContractor.value.id)
        ) {
          let contractorId = null;
          if (this.selectedContractor.id) {
            contractorId = this.selectedContractor.id;
          } else {
            contractorId = this.selectedContractor.value.id;
          }
          const result = await axios.get(`/contractor/${contractorId}`);
          this.contractorContactsAllData = result.data.contractor.contacts;
          this.contractorContacts = result.data.contractor.contacts.map(con => {
            return {
              text: `${con.name} (${con.phone})`,
              value: con.id
            };
          });
          this.contractorEmail = '';
        } else {
          this.selectedContractor = null;
          this.sendToContractor = false;
          this.selectedContact = null;
          this.contractorEmail = '';
        }
      } catch (error) {
        this.selectedContractor = null;
        this.sendToContractor = false;
        this.selectedContact = null;
        this.contractorEmail = '';
      }
    },
    onInfraChange() {
      if (
        this.selectedInfrastructure.id ||
        this.selectedInfrastructure.value.id
      ) {
        this.recomendedContractors = [];
        let selectedInfra = null;
        if (this.selectedInfrastructure.id) {
          selectedInfra = this.selectedInfrastructure;
        } else {
          selectedInfra = this.selectedInfrastructure.value;
        }
        for (const [
          index,
          contractorId
        ] of selectedInfra.contractors.entries()) {
          const contractor = this.contractors.find(
            c => c.value.id == contractorId
          );
          if (contractor) {
            if (index == selectedInfra.contractors.length - 1) {
              this.recomendedContractors.push({
                text: contractor.text,
                value: contractor.value
              });
            } else {
              this.recomendedContractors.push({
                text: contractor.text + ', ',
                value: contractor.value
              });
            }
          }
        }
      }
    },
    selectRecomendedContractor(contractor) {
      this.selectedContractor = contractor;
      this.onContractorChange();
    },
    onDrop(e) {
      e.stopPropagation();
      e.preventDefault();
      var files = e.dataTransfer.files;
      this.files.push(...files);
    },
    addFile() {
      if (this.files.length > 0) {
        return;
      }
      if (this.removingFile) {
        this.removingFile = false;
        return;
      }
      this.$refs.uploadBtn.openFileSelect();
    },
    addMoreFiles() {
      this.$refs.uploadBtn.openFileSelect();
    },
    getFiles(load) {
      for (let l of load) {
        this.files.push(l);
      }
    },
    removeUploadedFile(index) {
      this.removingFile = true;
      this.files.splice(index, 1);
    },
    validateInput() {
      if (this.ticket.title === '') {
        this.errorMessage = 'Morate popuniti naslov';
        return false;
      }
      if (this.ticket.description === '') {
        this.errorMessage = 'Morate popuniti opis';
        return false;
      }
      if (this.ticket.title.length > 128) {
        this.errorMessage = 'Naslov tiketa ne može imati preko 128 karaktera';
        return false;
      }
      if (this.ticket.description.length > 1000) {
        this.errorMessage = 'Opis tiketa ne može imati preko 1000 karaktera';
        return false;
      }
      if (this.sendToContractor && this.contractorEmail == '') {
        this.errorMessage =
          'Morate uneti email servisera na koji će biti poslat tiket';
        return false;
      }
      if (
        this.sendToContractor &&
        !utilService.isEmailValid(this.contractorEmail)
      ) {
        this.errorMessage =
          'Morate uneti validan email servisera na koji će biti poslat tiket';
        return false;
      }
      return true;
    },
    submitMedia() {
      if (this.loading) {
        return;
      }

      this.errorOccurred = false;

      if (!this.validateInput()) {
        this.errorOccurred = true;
        return;
      }
      this.loadingStarted();

      if (this.files.length === 0) {
        this.submitTicket();
        return;
      }

      axios
        .post('/media/add', this.formatMediaForSubmit(), {
          headers: {
            'Content-Type': 'multipart/form-data'
          }
        })
        .then(({ data }) => {
          this.ticket.mediaIds = data.ids;
          this.submitTicket();
        })
        .catch(error => {
          this.loadingFinished();
          console.log(error);
          this.showFailModal();
        });
    },
    formatMediaForSubmit() {
      let fd = new FormData();
      for (let i = 0; i < this.files.length; i++) {
        fd.append('files[]', this.files[i], this.files[i].name);
      }
      fd.append('type', 'community');
      fd.append(
        'community_id',
        this.$store.getters.getActiveCommunity.community_id
      );
      return fd;
    },
    submitTicket() {
      this.ticket.memberId = this.$store.getters.getActiveCommunity.member_id;
      if (this.selectedContractor) {
        if (this.selectedContractor.value) {
          this.ticket.contractorId = this.selectedContractor.value.id;
        } else {
          this.ticket.contractorId = this.selectedContractor.id;
        }
      }
      if (this.selectedContact) {
        this.ticket.contractorContactId = this.selectedContact;
      }
      if (this.selectedInfrastructure) {
        this.ticket.communityInfrastructureId = this.selectedInfrastructure.id;
      }
      // set date and contractor integration parameters
      this.ticket.ticketDate = DateTime.fromISO(this.dateCreated).toFormat(
        'yyyy-MM-dd HH:mm:ss'
      );
      this.ticket.forwardTicket = this.sendToContractor ? 1 : 0;
      this.ticket.forwardToEmail = this.contractorEmail;
      axios
        .post('/tickets', this.ticket)
        .then(() => {
          this.getTicketsByCommunity({
            memberId: this.$store.getters.getActiveCommunity.member_id,
            communityId: this.$store.getters.getActiveCommunity.id
          });
          this.loadingFinished();
          this.closeModal();
          this.showSuccessModal();
        })
        .catch(error => {
          this.loadingFinished();
          this.showFailModal();
        });
    }
  }
};
</script>
<style scoped lang="scss">
form {
  .col-form-label {
    width: auto;
  }
}
.contractor-email {
  label {
    width: auto;
  }
}
//--------------
.upload-more-wrapper {
  width: 100%;
}
input[type='radio'] {
  position: absolute;
  visibility: hidden;
  display: none;
}

label {
  display: inline-block;
  margin-bottom: 0;
  width: 9rem;
}
.recomended-contractor {
  color: var(--primary-color);
  // border-bottom: 1px solid var(--primary-color);
  cursor: pointer;
}

.contractor-email-wrapper {
  margin-top: 16px;
  display: flex;
  height: 25px;
  width: 100%;
  label.col-form-label {
    width: 300px;
    display: flex;
    align-items: center;
  }
  .ticket-cb {
    margin: 0 0 0 32px;
  }
}
.privacy-lbl {
  color: var(--primary-color);
  display: inline-block;
  cursor: pointer;
  padding: 5px 20px;
  margin-bottom: 0;
  width: 9rem;
  text-align: center;
}

input[type='radio']:checked + label {
  color: white;
  background: var(--primary-color);
}

label + input[type='radio'] {
  border-left: solid 1px var(--primary-color);
}

.radio-group {
  border: solid 1px var(--primary-color);
  /*display: inline-block;*/
  margin-top: calc(0.5rem + 1px);
  margin-bottom: calc(0.5rem + 1px);
  border-radius: 10px;
  overflow: hidden;
}

#radio-wrapper {
  display: flex;
  position: relative;
  flex-flow: column;
  align-items: center;
  padding-bottom: 25px;

  .private-help {
    position: absolute;
    top: 45px;
    color: var(--primary-color-lighten);
    font-size: 14px;
    padding-top: 8px;
  }
}

textarea.form-control {
  resize: none;
  width: 100%;
  height: 110px;
}
#description-area {
  width: 66%;
}
#first-section {
  display: inline-flex;
  height: 100%;
  width: 100%;
}
#upload-area {
  display: block;
  margin-left: 9px;
  width: 34%;
  height: 100%;
}
#uploaded-files {
  border: 1px dotted var(--primary-color);
  border-radius: 0.25rem;
  height: 110px;
  resize: none;
  max-height: 134px;
  overflow-y: auto;
  padding: 5px;
}

.file {
  border-bottom: solid 1px lightgray;
  font-size: 15px;
  width: 100%;
  display: inline-flex;
  vertical-align: center;
  p {
    max-width: 100%;
    margin-bottom: 2px;
  }
}

.del--mod {
  margin-left: auto;
  cursor: pointer;
  color: red;
  top: 4.7em;
  right: 1.7em;
}

.footer {
  display: block;
  width: 100%;
  text-align: center;
}
.buttons {
  display: inline-flex;
  float: right;
}

.error {
  float: left;
  margin-left: 15px;
}

.err-msg {
  text-align: center;
  color: red;
}
</style>
